import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class TermsModal extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      showModal: this.props.showModal || false,
      submitting: false,
    }
    this.handleAccept = this.handleAccept.bind(this)
  }

  handleAccept() {
    if (this.state.submitting) return
    this.setState({ submitting: true })
    const params = { user_id: this.props.userId }
    if (this.props.marinaSide) {
      params.marina_side = true
    }
    $.post(this.props.endpoint, params)
      .done(() => {
        this.setState({ showModal: false, submitting: false })
      })
      .fail(() => {
        this.setState({ submitting: false })
      })
  }

  render() {
    return (
      <Modal
        isOpen={this.state.showModal}
        size="mediumFixed"
        dismissable={false}
      >
        <Modal.Body>
          <div className="text-sm leading-relaxed">{this.props.children}</div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex md:justify-end">
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleAccept}
              disabled={this.state.submitting}
            >
              {this.state.submitting ? "Saving..." : "I Accept"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

TermsModal.propTypes = {
  showModal: PropTypes.bool,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  marinaSide: PropTypes.bool,
  endpoint: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default TermsModal
